module.exports = __webpack_public_path__ + "img/sqty_banner.9079c301.png";